import * as React from 'react';

import { useExperimentByName, useSaveSource } from '../../hooks';
import { MY_HOME_REDESIGN_EXPERIMENT } from '../../constants/experiments';
import { PageContainerA, PageContainerB, PageContainerC } from './containers';

export const PageContainer: React.FC = () => {
  useSaveSource();

  const experimentGroup = useExperimentByName(MY_HOME_REDESIGN_EXPERIMENT);

  switch (experimentGroup) {
    case 'B':
      return <PageContainerB />;

    case 'C':
      return <PageContainerC />;

    default:
      return <PageContainerA />;
  }
};
